import React, { useEffect, useState } from 'react'
import { useCountdown } from '../../hooks/UseCountdown'
import DateTimeDisplay from './DateTimeDisplay'
import { CircularProgressbar } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'

const ExpiredNotice = () => {
  return (
    <div className="expired-notice">
      <span>Expired!!!</span>
      <p>Please select a future date and time.</p>
    </div>
  )
}

const ShowCounter = ({ days, hours, minutes, seconds, miliseconds, percentage }) => {
  return (
    <div className="show-counter">
      <CircularProgressbar
        value={percentage}
        text={`${String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0')}`}
      />
    </div>
  )
}

const CountdownTimer = ({ targetDate, onEnd }) => {
  let [days, hours, minutes, seconds, miliseconds, percentage] = useCountdown(targetDate)
  const [running, setRunning] = useState(true)
  //   const [percentage, setPercentage] = useState(100);

  //   useEffect(() => {
  //     const interval = setInterval(() => {
  //       setCountDown(countDownDate - new Date().getTime());
  //       setPercentage(((countDownDate - new Date().getTime()) * 100) / totalTime)
  //     }, 10);

  //     return () => clearInterval(interval);
  //   }, [countDownDate]);

  if (days + hours + minutes + seconds < 0) {
    days = minutes = hours = seconds = 0
  }

  useEffect(() => {
    if (days + hours + minutes + seconds <= 0 && running) {
      setRunning(false)
      onEnd()
    }
  })

  return (
    <ShowCounter
      days={days}
      hours={hours}
      minutes={minutes}
      seconds={seconds}
      miliseconds={miliseconds}
      percentage={percentage}
    />
  )
}

export default CountdownTimer
